<mat-card class="decoration-card">
    <mat-card-content>

        <mat-toolbar *ngIf="!isReadonly">
            <span class="example-spacer"></span>

            <button mat-icon-button matTooltip="add a trail machinery" (click)="create()" *ngIf="!isReadonly">
                <mat-icon>plus_one</mat-icon>
            </button>
        </mat-toolbar>

        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
            <!--- Note that these columns can be defined in any order.
              The actual rendered columns are set as a property on the row definition" -->

            <!-- machinery_name Column -->
            <ng-container matColumnDef="machinery_name">
                <th mat-header-cell *matHeaderCellDef> Name </th>
                <td mat-cell *matCellDef="let element"> {{element.machinery_name}} </td>
            </ng-container>

            <!-- maintenance_check Column -->
            <ng-container matColumnDef="maintenance_check">
                <th mat-header-cell *matHeaderCellDef> Maintenance checked? </th>
                <td mat-cell *matCellDef="let element"> {{element.maintenance_check_text}} </td>
            </ng-container>

            <!-- outstanding_maintenance Column -->
            <ng-container matColumnDef="outstanding_maintenance">
                <th mat-header-cell *matHeaderCellDef> Outstanding Maintenance </th>
                <td mat-cell *matCellDef="let element"> {{element.outstanding_maintenance}} </td>
            </ng-container>

            <!-- last_oil_analysis_date Column -->
            <ng-container matColumnDef="last_oil_analysis_date">
                <th mat-header-cell *matHeaderCellDef> Last oil-analysis Date </th>
                <td mat-cell *matCellDef="let element"> {{element.last_oil_analysis_date}} </td>
            </ng-container>

            <!-- last_oil_analysis_result Column -->
            <ng-container matColumnDef="last_oil_analysis_result">
                <th mat-header-cell *matHeaderCellDef> Analysis Result Maintenance </th>
                <td mat-cell *matCellDef="let element"> {{element.last_oil_analysis_result}} </td>
            </ng-container>

            <!-- running_hours_at_present Column -->
            <ng-container matColumnDef="running_hours_at_present">
                <th mat-header-cell *matHeaderCellDef> Running Hours </th>
                <td mat-cell *matCellDef="let element"> {{element.running_hours_at_present}} </td>
            </ng-container>

            <!-- last_major_overhaul Column -->
            <ng-container matColumnDef="last_major_overhaul">
                <th mat-header-cell *matHeaderCellDef> Last Major Overhaul </th>
                <td mat-cell *matCellDef="let element"> {{element.last_major_overhaul}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row (click)="selectTrailMachinery(row)" *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

    </mat-card-content>
</mat-card>